const mixins = {
	data() {
		return {};
	},
	onLoad() {},
	methods: {},
};
const mixinsMobile = {
	install: function(Vue) {
		Vue.mixin(mixins);
	},
};

export default mixinsMobile;
